// src/lib/translations.js — Multi-language strings
// Add new keys here. Every language falls back to English if key is missing.

export const TRANSLATIONS = {
  /* ═══════════════ ENGLISH ═══════════════ */
  en: {
    // Nav
    search: "Search items..",
    home: "Home",
    feed: "Marketplace",
    vehicles: "Vehicles",
    mobiles: "Mobiles",
    electronics: "Electronics",
    property: "Property",
    toys: "Toys",
    premium: "Premium",
    messenger: "Messenger",
    momento: "Momento",
    aiStudio: "AI Studio",
    postAd: "Post an Ad",
    myListings: "My Listings",
    liveSales: "Live Sales",
    settings: "Settings",
    contactUs: "Contact Us",
    adminDashboard: "Admin Dashboard",
    login: "Log In",
    signup: "Sign Up",
    logout: "Logout",
    editProfile: "Edit Profile",
    currentPlan: "Current plan",
    reviews: "reviews",
    noReviews: "No reviews",

    // Locale picker
    setLanguageAndCurrency: "Set language and currency",
    setLanguageDesc: "Select your preferred language and currency. You can update the settings at any time.",
    language: "Language",
    currency: "Currency",
    save: "Save",
    cancel: "Cancel",

    // Product / listing
    viewDetails: "View Details",
    visit: "Visit",
    buy: "Buy",
    sold: "Sold",
    chat: "Chat",
    call: "Call",
    whatsapp: "WhatsApp",
    addToBag: "Add to bag",
    buyNow: "Buy now",
    quantity: "Quantity",
    description: "Description",
    specifications: "Specifications",
    safetyTips: "Safety Tips",

    // Filters
    filterBy: "Filter by",
    resetAll: "Reset all",
    priceRange: "Price Range / Hour",
    from: "From",
    to: "To",
    carBrand: "Car Brand",
    searchBrand: "Search brand",
    condition: "Condition",
    color: "Color",
    availableNow: "Available now only",
    show: "Show",
    results: "results",

    // Cart
    yourCart: "Your Cart",
    emptyCart: "Your cart is empty",
    subtotal: "Subtotal",
    viewFullCart: "View full cart",

    // Messages
    typeMessage: "Write a message…",
    selectConversation: "Select a conversation first",
    noConversation: "No conversation selected",
    quickReplies: "Quick replies",
    chattingAbout: "Chatting about",

    // Misc
    loading: "Loading…",
    saveThis: "Save",
    saved: "Saved",
    share: "Share",
    report: "Report",

    /* ⭐ NEW — Navbar / Mega menu / Mobile sheet */
    menu: "Menu",
    searchFor: "Search for",
    popularCategories: "Popular categories",
    browseAllCategories: "Browse all categories",
    links: "links",
    user: "User",
    item: "item",
    items: "items",
    moreItems: "more items",
    in: "In",
    join: "Join",
    new: "New",
    pro: "Pro",
    free: "Free",
    seller: "Seller",
    starter: "Starter",
    proSeller: "Pro Seller",
    admin: "Admin",
    rating: "Rating",
    level: "Level",
    xp: "XP",
    myAccount: "My Account",
    buyAndSell: "Buy & Sell",
    discover: "Discover",
    selling: "Selling",
    accountGroup: "Account",
    getStarted: "Get Started",
    analytics: "Analytics",
    subscription: "Subscription",
    managePlan: "Manage Plan",
    upgradePlan: "Upgrade Plan",
    switchToDark: "Switch to Dark",
    switchToLight: "Switch to Light",
    upgradeToSeller: "Upgrade to Seller",
    upgradeToSellerDesc: "30 listings, AI Studio & 1 boost",
    createFreeAccount: "Create Free Account",

    // Mega menu descriptions
    megaVehiclesDesc: "Cars, bikes, trucks",
    megaMobilesDesc: "Phones & tablets",
    megaElectronicsDesc: "Laptops, TVs, audio",
    megaPropertyDesc: "Homes, plots, commercial",
    megaFeedDesc: "All live listings",
    megaMessengerDesc: "Buyer & seller chat",
    megaMomentoDesc: "Stories & reels",
    megaAiStudioDesc: "Generate & edit images",
    megaPostAdDesc: "List a new item",
    megaMyListingsDesc: "Manage your ads",
    megaLiveSalesDesc: "Sales & wallet",
    megaPremiumDesc: "Upgrade & manage plan",

    // Browse group descriptions
    browseMobilesDesc: "iPhone, Samsung, Xiaomi & more",
    browseVehiclesDesc: "Sedans, SUVs, motorcycles",
    browseElectronicsDesc: "Laptops, TVs, cameras",
    browsePropertyDesc: "Homes, plots, commercial",
    browseFeedDesc: "All live listings",
    browseMessengerDesc: "Chat with buyers & sellers",
    browseMomentoDesc: "Share your moments & stories",
    browseAiStudioDesc: "Generate images & remove BG",

    // Account group descriptions
    acctPostAdDesc: "List a new item",
    acctMyListingsDesc: "Manage your ads",
    acctAnalyticsDesc: "Views & performance",
    acctSettingsDesc: "Profile & preferences",
    acctLiveSalesDesc: "Sales & Value Sold",
    acctPremiumDesc: "Upgrade or manage",

    // Guest nav section anchors
    features: "Features",
    assets: "Assets",
    pricing: "Pricing",
    faq: "FAQ",
    protection: "Protection",
  },

  /* ═══════════════ URDU ═══════════════ */
  ur: {
    // Nav
    search: "آئٹمز تلاش کریں..",
    home: "ہوم",
    feed: "مارکیٹ پلیس",
    vehicles: "گاڑیاں",
    mobiles: "موبائلز",
    electronics: "الیکٹرانکس",
    property: "پراپرٹی",
    toys: "کھلونے",
    premium: "پریمیم",
    messenger: "میسنجر",
    momento: "مومینٹو",
    aiStudio: "اے آئی اسٹوڈیو",
    postAd: "اشتہار لگائیں",
    myListings: "میری لسٹنگز",
    liveSales: "لائیو سیلز",
    settings: "سیٹنگز",
    contactUs: "ہم سے رابطہ",
    adminDashboard: "ایڈمن ڈیش بورڈ",
    login: "لاگ ان",
    signup: "سائن اپ",
    logout: "لاگ آؤٹ",
    editProfile: "پروفائل ایڈٹ کریں",
    currentPlan: "موجودہ پلان",
    reviews: "ریویوز",
    noReviews: "کوئی ریویو نہیں",

    // Locale picker
    setLanguageAndCurrency: "زبان اور کرنسی سیٹ کریں",
    setLanguageDesc: "اپنی پسند کی زبان اور کرنسی منتخب کریں۔ آپ کسی بھی وقت سیٹنگز تبدیل کر سکتے ہیں۔",
    language: "زبان",
    currency: "کرنسی",
    save: "محفوظ کریں",
    cancel: "منسوخ",

    // Product / listing
    viewDetails: "تفصیلات دیکھیں",
    visit: "دیکھیں",
    buy: "خریدیں",
    sold: "بک گیا",
    chat: "چیٹ",
    call: "کال",
    whatsapp: "واٹس ایپ",
    addToBag: "بیگ میں ڈالیں",
    buyNow: "ابھی خریدیں",
    quantity: "تعداد",
    description: "تفصیل",
    specifications: "تفصیلات",
    safetyTips: "حفاظتی مشورے",

    // Filters
    filterBy: "فلٹر کریں",
    resetAll: "سب ری سیٹ کریں",
    priceRange: "قیمت کی حد / فی گھنٹہ",
    from: "سے",
    to: "تک",
    carBrand: "گاڑی کا برانڈ",
    searchBrand: "برانڈ تلاش کریں",
    condition: "حالت",
    color: "رنگ",
    availableNow: "صرف ابھی دستیاب",
    show: "دکھائیں",
    results: "نتائج",

    // Cart
    yourCart: "آپ کا کارٹ",
    emptyCart: "آپ کا کارٹ خالی ہے",
    subtotal: "کل رقم",
    viewFullCart: "مکمل کارٹ دیکھیں",

    // Messages
    typeMessage: "پیغام لکھیں…",
    selectConversation: "پہلے گفتگو منتخب کریں",
    noConversation: "کوئی گفتگو منتخب نہیں",
    quickReplies: "فوری جوابات",
    chattingAbout: "بات چیت کس بارے میں",

    // Misc
    loading: "لوڈ ہو رہا ہے…",
    saveThis: "محفوظ کریں",
    saved: "محفوظ ہو گیا",
    share: "شیئر",
    report: "رپورٹ",

    /* ⭐ NEW */
    menu: "مینو",
    searchFor: "کے لیے تلاش کریں",
    popularCategories: "مشہور کیٹیگریز",
    browseAllCategories: "تمام کیٹیگریز دیکھیں",
    links: "لنکس",
    user: "صارف",
    item: "آئٹم",
    items: "آئٹمز",
    moreItems: "مزید آئٹمز",
    in: "ان",
    join: "شامل ہوں",
    new: "نیا",
    pro: "پرو",
    free: "فری",
    seller: "سیلر",
    starter: "اسٹارٹر",
    proSeller: "پرو سیلر",
    admin: "ایڈمن",
    rating: "ریٹنگ",
    level: "لیول",
    xp: "ایکس پی",
    myAccount: "میرا اکاؤنٹ",
    buyAndSell: "خرید و فروخت",
    discover: "دریافت کریں",
    selling: "فروخت",
    accountGroup: "اکاؤنٹ",
    getStarted: "شروع کریں",
    analytics: "تجزیات",
    subscription: "سبسکرپشن",
    managePlan: "پلان منیج کریں",
    upgradePlan: "پلان اپ گریڈ کریں",
    switchToDark: "ڈارک موڈ پر جائیں",
    switchToLight: "لائٹ موڈ پر جائیں",
    upgradeToSeller: "سیلر بنیں",
    upgradeToSellerDesc: "30 لسٹنگز، اے آئی اسٹوڈیو اور 1 بوسٹ",
    createFreeAccount: "مفت اکاؤنٹ بنائیں",

    megaVehiclesDesc: "کاریں، بائیکس، ٹرک",
    megaMobilesDesc: "فونز اور ٹیبلٹس",
    megaElectronicsDesc: "لیپ ٹاپس، ٹی وی، آڈیو",
    megaPropertyDesc: "گھر، پلاٹ، کمرشل",
    megaFeedDesc: "تمام لائیو لسٹنگز",
    megaMessengerDesc: "خریدار اور بیچنے والے کی چیٹ",
    megaMomentoDesc: "اسٹوریز اور ریلز",
    megaAiStudioDesc: "تصاویر بنائیں اور ایڈٹ کریں",
    megaPostAdDesc: "نیا آئٹم لسٹ کریں",
    megaMyListingsDesc: "اپنے اشتہارات منیج کریں",
    megaLiveSalesDesc: "سیلز اور والٹ",
    megaPremiumDesc: "پلان اپ گریڈ یا منیج کریں",

    browseMobilesDesc: "آئی فون، سام سنگ، شیاؤمی اور مزید",
    browseVehiclesDesc: "سیڈان، ایس یو وی، موٹرسائیکل",
    browseElectronicsDesc: "لیپ ٹاپس، ٹی وی، کیمرے",
    browsePropertyDesc: "گھر، پلاٹ، کمرشل",
    browseFeedDesc: "تمام لائیو لسٹنگز",
    browseMessengerDesc: "خریداروں اور بیچنے والوں سے چیٹ کریں",
    browseMomentoDesc: "اپنے لمحات اور کہانیاں شیئر کریں",
    browseAiStudioDesc: "تصاویر بنائیں اور بی جی ہٹائیں",

    acctPostAdDesc: "نیا آئٹم لسٹ کریں",
    acctMyListingsDesc: "اپنے اشتہارات منیج کریں",
    acctAnalyticsDesc: "ویوز اور پرفارمنس",
    acctSettingsDesc: "پروفائل اور ترجیحات",
    acctLiveSalesDesc: "سیلز اور مالیت",
    acctPremiumDesc: "اپ گریڈ یا منیج کریں",

    features: "خصوصیات",
    assets: "اثاثے",
    pricing: "قیمتیں",
    faq: "سوالات",
    protection: "تحفظ",
  },

  /* ═══════════════ ARABIC ═══════════════ */
  ar: {
    search: "ابحث عن العناصر..",
    home: "الرئيسية",
    feed: "السوق",
    vehicles: "السيارات",
    mobiles: "الهواتف",
    electronics: "الإلكترونيات",
    property: "العقارات",
    toys: "الألعاب",
    premium: "بريميوم",
    messenger: "الرسائل",
    momento: "مومينتو",
    aiStudio: "استوديو الذكاء",
    postAd: "أعلن الآن",
    myListings: "قوائمي",
    liveSales: "المبيعات المباشرة",
    settings: "الإعدادات",
    contactUs: "اتصل بنا",
    adminDashboard: "لوحة الإدارة",
    login: "تسجيل الدخول",
    signup: "إنشاء حساب",
    logout: "تسجيل الخروج",
    editProfile: "تعديل الملف",
    currentPlan: "الخطة الحالية",
    reviews: "تقييمات",
    noReviews: "لا توجد تقييمات",
    setLanguageAndCurrency: "حدد اللغة والعملة",
    setLanguageDesc: "اختر اللغة والعملة المفضلة. يمكنك تحديث الإعدادات في أي وقت.",
    language: "اللغة",
    currency: "العملة",
    save: "حفظ",
    cancel: "إلغاء",
    viewDetails: "عرض التفاصيل",
    visit: "زيارة",
    buy: "شراء",
    sold: "مُباع",
    chat: "دردشة",
    call: "اتصال",
    whatsapp: "واتساب",
    addToBag: "أضف إلى السلة",
    buyNow: "اشتر الآن",
    quantity: "الكمية",
    description: "الوصف",
    specifications: "المواصفات",
    safetyTips: "نصائح الأمان",
    filterBy: "تصفية حسب",
    resetAll: "إعادة تعيين الكل",
    priceRange: "نطاق السعر / ساعة",
    from: "من",
    to: "إلى",
    carBrand: "علامة السيارة",
    searchBrand: "ابحث عن العلامة",
    condition: "الحالة",
    color: "اللون",
    availableNow: "متاح الآن فقط",
    show: "عرض",
    results: "نتائج",
    yourCart: "سلتك",
    emptyCart: "سلتك فارغة",
    subtotal: "المجموع الفرعي",
    viewFullCart: "عرض السلة كاملة",
    typeMessage: "اكتب رسالة…",
    selectConversation: "اختر محادثة أولاً",
    noConversation: "لا توجد محادثة محددة",
    quickReplies: "ردود سريعة",
    chattingAbout: "تتحدث عن",
    loading: "جار التحميل…",
    saveThis: "حفظ",
    saved: "محفوظ",
    share: "مشاركة",
    report: "إبلاغ",

    menu: "القائمة",
    searchFor: "ابحث عن",
    popularCategories: "الفئات الشائعة",
    browseAllCategories: "تصفح جميع الفئات",
    links: "روابط",
    user: "المستخدم",
    item: "عنصر",
    items: "عناصر",
    moreItems: "عناصر أخرى",
    in: "دخول",
    join: "انضم",
    new: "جديد",
    pro: "برو",
    free: "مجاني",
    seller: "بائع",
    starter: "مبتدئ",
    proSeller: "بائع برو",
    admin: "مشرف",
    rating: "التقييم",
    level: "المستوى",
    xp: "نقاط الخبرة",
    myAccount: "حسابي",
    buyAndSell: "بيع وشراء",
    discover: "اكتشف",
    selling: "البيع",
    accountGroup: "الحساب",
    getStarted: "ابدأ الآن",
    analytics: "التحليلات",
    subscription: "الاشتراك",
    managePlan: "إدارة الخطة",
    upgradePlan: "ترقية الخطة",
    switchToDark: "التبديل إلى الداكن",
    switchToLight: "التبديل إلى الفاتح",
    upgradeToSeller: "ترقية إلى بائع",
    upgradeToSellerDesc: "30 قائمة، استوديو AI و 1 تعزيز",
    createFreeAccount: "إنشاء حساب مجاني",

    megaVehiclesDesc: "سيارات، دراجات، شاحنات",
    megaMobilesDesc: "هواتف وأجهزة لوحية",
    megaElectronicsDesc: "لابتوبات، تلفزيونات، صوتيات",
    megaPropertyDesc: "منازل، أراضي، تجاري",
    megaFeedDesc: "جميع القوائم المباشرة",
    megaMessengerDesc: "محادثة المشتري والبائع",
    megaMomentoDesc: "قصص وريلز",
    megaAiStudioDesc: "أنشئ وعدل الصور",
    megaPostAdDesc: "أضف عنصرًا جديدًا",
    megaMyListingsDesc: "إدارة إعلاناتك",
    megaLiveSalesDesc: "المبيعات والمحفظة",
    megaPremiumDesc: "ترقية أو إدارة الخطة",

    browseMobilesDesc: "آيفون، سامسونج، شاومي والمزيد",
    browseVehiclesDesc: "سيدان، SUV، دراجات نارية",
    browseElectronicsDesc: "لابتوبات، تلفزيونات، كاميرات",
    browsePropertyDesc: "منازل، أراضي، تجاري",
    browseFeedDesc: "جميع القوائم المباشرة",
    browseMessengerDesc: "تحدث مع المشترين والبائعين",
    browseMomentoDesc: "شارك لحظاتك وقصصك",
    browseAiStudioDesc: "أنشئ صورًا وأزل الخلفية",

    acctPostAdDesc: "أضف عنصرًا جديدًا",
    acctMyListingsDesc: "إدارة إعلاناتك",
    acctAnalyticsDesc: "المشاهدات والأداء",
    acctSettingsDesc: "الملف والتفضيلات",
    acctLiveSalesDesc: "المبيعات والقيمة",
    acctPremiumDesc: "ترقية أو إدارة",

    features: "المميزات",
    assets: "الأصول",
    pricing: "الأسعار",
    faq: "الأسئلة الشائعة",
    protection: "الحماية",
  },

  /* ═══════════════ HINDI ═══════════════ */
  hi: {
    search: "आइटम खोजें..",
    home: "होम",
    feed: "मार्केटप्लेस",
    vehicles: "वाहन",
    mobiles: "मोबाइल",
    electronics: "इलेक्ट्रॉनिक्स",
    property: "संपत्ति",
    toys: "खिलौने",
    premium: "प्रीमियम",
    messenger: "मैसेंजर",
    momento: "मोमेंटो",
    aiStudio: "एआई स्टूडियो",
    postAd: "विज्ञापन दें",
    myListings: "मेरी लिस्टिंग",
    liveSales: "लाइव सेल्स",
    settings: "सेटिंग्स",
    contactUs: "संपर्क करें",
    adminDashboard: "एडमिन डैशबोर्ड",
    login: "लॉग इन",
    signup: "साइन अप",
    logout: "लॉग आउट",
    editProfile: "प्रोफ़ाइल एडिट करें",
    currentPlan: "मौजूदा प्लान",
    reviews: "समीक्षाएं",
    noReviews: "कोई समीक्षा नहीं",
    setLanguageAndCurrency: "भाषा और मुद्रा सेट करें",
    setLanguageDesc: "अपनी पसंदीदा भाषा और मुद्रा चुनें। आप कभी भी सेटिंग्स बदल सकते हैं।",
    language: "भाषा",
    currency: "मुद्रा",
    save: "सहेजें",
    cancel: "रद्द करें",
    viewDetails: "विवरण देखें",
    visit: "देखें",
    buy: "खरीदें",
    sold: "बिक गया",
    chat: "चैट",
    call: "कॉल",
    whatsapp: "व्हाट्सएप",
    addToBag: "बैग में डालें",
    buyNow: "अभी खरीदें",
    quantity: "मात्रा",
    description: "विवरण",
    specifications: "विनिर्देश",
    safetyTips: "सुरक्षा सुझाव",
    filterBy: "फ़िल्टर करें",
    resetAll: "सभी रीसेट करें",
    priceRange: "मूल्य सीमा / घंटा",
    from: "से",
    to: "तक",
    carBrand: "कार ब्रांड",
    searchBrand: "ब्रांड खोजें",
    condition: "हालत",
    color: "रंग",
    availableNow: "केवल अभी उपलब्ध",
    show: "दिखाएं",
    results: "परिणाम",
    yourCart: "आपका कार्ट",
    emptyCart: "आपका कार्ट खाली है",
    subtotal: "उप-योग",
    viewFullCart: "पूरा कार्ट देखें",
    typeMessage: "संदेश लिखें…",
    selectConversation: "पहले बातचीत चुनें",
    noConversation: "कोई बातचीत चयनित नहीं",
    quickReplies: "त्वरित उत्तर",
    chattingAbout: "बातचीत विषय",
    loading: "लोड हो रहा है…",
    saveThis: "सहेजें",
    saved: "सहेजा गया",
    share: "साझा करें",
    report: "रिपोर्ट",

    menu: "मेनू",
    searchFor: "के लिए खोजें",
    popularCategories: "लोकप्रिय श्रेणियां",
    browseAllCategories: "सभी श्रेणियां देखें",
    links: "लिंक",
    user: "उपयोगकर्ता",
    item: "आइटम",
    items: "आइटम",
    moreItems: "और आइटम",
    in: "इन",
    join: "जॉइन",
    new: "नया",
    pro: "प्रो",
    free: "फ्री",
    seller: "विक्रेता",
    starter: "स्टार्टर",
    proSeller: "प्रो विक्रेता",
    admin: "एडमिन",
    rating: "रेटिंग",
    level: "स्तर",
    xp: "XP",
    myAccount: "मेरा खाता",
    buyAndSell: "खरीदें और बेचें",
    discover: "खोजें",
    selling: "बिक्री",
    accountGroup: "खाता",
    getStarted: "शुरू करें",
    analytics: "विश्लेषण",
    subscription: "सदस्यता",
    managePlan: "प्लान प्रबंधित करें",
    upgradePlan: "प्लान अपग्रेड करें",
    switchToDark: "डार्क पर स्विच करें",
    switchToLight: "लाइट पर स्विच करें",
    upgradeToSeller: "सेलर बनें",
    upgradeToSellerDesc: "30 लिस्टिंग, AI स्टूडियो और 1 बूस्ट",
    createFreeAccount: "मुफ्त खाता बनाएं",

    megaVehiclesDesc: "कार, बाइक, ट्रक",
    megaMobilesDesc: "फोन और टैबलेट",
    megaElectronicsDesc: "लैपटॉप, टीवी, ऑडियो",
    megaPropertyDesc: "घर, प्लॉट, कमर्शियल",
    megaFeedDesc: "सभी लाइव लिस्टिंग",
    megaMessengerDesc: "खरीदार और विक्रेता चैट",
    megaMomentoDesc: "स्टोरीज और रील्स",
    megaAiStudioDesc: "इमेज बनाएं और एडिट करें",
    megaPostAdDesc: "नया आइटम लिस्ट करें",
    megaMyListingsDesc: "अपने विज्ञापन प्रबंधित करें",
    megaLiveSalesDesc: "बिक्री और वॉलेट",
    megaPremiumDesc: "प्लान अपग्रेड या प्रबंधित करें",

    browseMobilesDesc: "iPhone, Samsung, Xiaomi और अधिक",
    browseVehiclesDesc: "सेडान, SUV, मोटरसाइकिल",
    browseElectronicsDesc: "लैपटॉप, टीवी, कैमरे",
    browsePropertyDesc: "घर, प्लॉट, कमर्शियल",
    browseFeedDesc: "सभी लाइव लिस्टिंग",
    browseMessengerDesc: "खरीदारों और विक्रेताओं से चैट करें",
    browseMomentoDesc: "अपने पल और कहानियाँ साझा करें",
    browseAiStudioDesc: "इमेज बनाएं और BG हटाएं",

    acctPostAdDesc: "नया आइटम लिस्ट करें",
    acctMyListingsDesc: "अपने विज्ञापन प्रबंधित करें",
    acctAnalyticsDesc: "व्यूज और प्रदर्शन",
    acctSettingsDesc: "प्रोफ़ाइल और प्राथमिकताएं",
    acctLiveSalesDesc: "बिक्री और मूल्य",
    acctPremiumDesc: "अपग्रेड या प्रबंधित करें",

    features: "विशेषताएं",
    assets: "संपत्ति",
    pricing: "मूल्य निर्धारण",
    faq: "सामान्य प्रश्न",
    protection: "सुरक्षा",
  },

  /* ═══════════════ CHINESE ═══════════════ */
  zh: {
    search: "搜索物品..",
    home: "首页",
    feed: "市场",
    vehicles: "汽车",
    mobiles: "手机",
    electronics: "电子产品",
    property: "房产",
    toys: "玩具",
    premium: "会员",
    messenger: "消息",
    momento: "动态",
    aiStudio: "AI工作室",
    postAd: "发布广告",
    myListings: "我的发布",
    liveSales: "实时销售",
    settings: "设置",
    contactUs: "联系我们",
    adminDashboard: "管理面板",
    login: "登录",
    signup: "注册",
    logout: "退出",
    editProfile: "编辑资料",
    currentPlan: "当前方案",
    reviews: "评价",
    noReviews: "暂无评价",
    setLanguageAndCurrency: "设置语言和货币",
    setLanguageDesc: "选择您偏好的语言和货币。您可以随时更新设置。",
    language: "语言",
    currency: "货币",
    save: "保存",
    cancel: "取消",
    viewDetails: "查看详情",
    visit: "查看",
    buy: "购买",
    sold: "已售",
    chat: "聊天",
    call: "通话",
    whatsapp: "WhatsApp",
    addToBag: "加入购物袋",
    buyNow: "立即购买",
    quantity: "数量",
    description: "描述",
    specifications: "规格",
    safetyTips: "安全提示",
    filterBy: "筛选",
    resetAll: "重置全部",
    priceRange: "价格范围/小时",
    from: "从",
    to: "到",
    carBrand: "汽车品牌",
    searchBrand: "搜索品牌",
    condition: "成色",
    color: "颜色",
    availableNow: "仅显示可用",
    show: "显示",
    results: "结果",
    yourCart: "购物车",
    emptyCart: "购物车是空的",
    subtotal: "小计",
    viewFullCart: "查看完整购物车",
    typeMessage: "输入消息…",
    selectConversation: "请先选择对话",
    noConversation: "未选择对话",
    quickReplies: "快捷回复",
    chattingAbout: "正在聊天",
    loading: "加载中…",
    saveThis: "保存",
    saved: "已保存",
    share: "分享",
    report: "举报",

    menu: "菜单",
    searchFor: "搜索",
    popularCategories: "热门分类",
    browseAllCategories: "浏览所有分类",
    links: "链接",
    user: "用户",
    item: "项目",
    items: "项目",
    moreItems: "更多项目",
    in: "登录",
    join: "加入",
    new: "新",
    pro: "专业",
    free: "免费",
    seller: "卖家",
    starter: "入门",
    proSeller: "专业卖家",
    admin: "管理员",
    rating: "评分",
    level: "等级",
    xp: "经验",
    myAccount: "我的账户",
    buyAndSell: "买卖",
    discover: "发现",
    selling: "出售",
    accountGroup: "账户",
    getStarted: "开始",
    analytics: "数据分析",
    subscription: "订阅",
    managePlan: "管理方案",
    upgradePlan: "升级方案",
    switchToDark: "切换到深色",
    switchToLight: "切换到浅色",
    upgradeToSeller: "升级为卖家",
    upgradeToSellerDesc: "30 条列表、AI 工作室及 1 次推广",
    createFreeAccount: "创建免费账户",

    megaVehiclesDesc: "汽车、摩托车、卡车",
    megaMobilesDesc: "手机和平板",
    megaElectronicsDesc: "笔记本电脑、电视、音频",
    megaPropertyDesc: "房屋、土地、商业",
    megaFeedDesc: "所有实时列表",
    megaMessengerDesc: "买家与卖家聊天",
    megaMomentoDesc: "故事和短视频",
    megaAiStudioDesc: "生成并编辑图像",
    megaPostAdDesc: "发布新商品",
    megaMyListingsDesc: "管理您的广告",
    megaLiveSalesDesc: "销售与钱包",
    megaPremiumDesc: "升级或管理方案",

    browseMobilesDesc: "iPhone、三星、小米等",
    browseVehiclesDesc: "轿车、SUV、摩托车",
    browseElectronicsDesc: "笔记本电脑、电视、相机",
    browsePropertyDesc: "房屋、土地、商业",
    browseFeedDesc: "所有实时列表",
    browseMessengerDesc: "与买家和卖家聊天",
    browseMomentoDesc: "分享您的时刻和故事",
    browseAiStudioDesc: "生成图像并去除背景",

    acctPostAdDesc: "发布新商品",
    acctMyListingsDesc: "管理您的广告",
    acctAnalyticsDesc: "浏览量和表现",
    acctSettingsDesc: "个人资料和偏好",
    acctLiveSalesDesc: "销售和价值",
    acctPremiumDesc: "升级或管理",

    features: "功能",
    assets: "资源",
    pricing: "价格",
    faq: "常见问题",
    protection: "保护",
  },

  /* ═══════════════ SPANISH ═══════════════ */
  es: {
    search: "Buscar artículos..",
    home: "Inicio",
    feed: "Mercado",
    vehicles: "Vehículos",
    mobiles: "Móviles",
    electronics: "Electrónica",
    property: "Propiedades",
    toys: "Juguetes",
    premium: "Premium",
    messenger: "Mensajería",
    momento: "Momento",
    aiStudio: "Estudio IA",
    postAd: "Publicar anuncio",
    myListings: "Mis anuncios",
    liveSales: "Ventas en vivo",
    settings: "Ajustes",
    contactUs: "Contáctanos",
    adminDashboard: "Panel admin",
    login: "Iniciar sesión",
    signup: "Registrarse",
    logout: "Cerrar sesión",
    editProfile: "Editar perfil",
    currentPlan: "Plan actual",
    reviews: "reseñas",
    noReviews: "Sin reseñas",
    setLanguageAndCurrency: "Idioma y moneda",
    setLanguageDesc: "Seleccione su idioma y moneda preferidos. Puede actualizar la configuración en cualquier momento.",
    language: "Idioma",
    currency: "Moneda",
    save: "Guardar",
    cancel: "Cancelar",
    viewDetails: "Ver detalles",
    visit: "Visitar",
    buy: "Comprar",
    sold: "Vendido",
    chat: "Chatear",
    call: "Llamar",
    whatsapp: "WhatsApp",
    addToBag: "Añadir a la bolsa",
    buyNow: "Comprar ahora",
    quantity: "Cantidad",
    description: "Descripción",
    specifications: "Especificaciones",
    safetyTips: "Consejos de seguridad",
    filterBy: "Filtrar por",
    resetAll: "Restablecer",
    priceRange: "Rango de precio",
    from: "Desde",
    to: "Hasta",
    carBrand: "Marca del auto",
    searchBrand: "Buscar marca",
    condition: "Estado",
    color: "Color",
    availableNow: "Disponible ahora",
    show: "Mostrar",
    results: "resultados",
    yourCart: "Tu carrito",
    emptyCart: "Tu carrito está vacío",
    subtotal: "Subtotal",
    viewFullCart: "Ver carrito completo",
    typeMessage: "Escribe un mensaje…",
    selectConversation: "Selecciona una conversación",
    noConversation: "Sin conversación seleccionada",
    quickReplies: "Respuestas rápidas",
    chattingAbout: "Chateando sobre",
    loading: "Cargando…",
    saveThis: "Guardar",
    saved: "Guardado",
    share: "Compartir",
    report: "Reportar",

    menu: "Menú",
    searchFor: "Buscar",
    popularCategories: "Categorías populares",
    browseAllCategories: "Explorar todas las categorías",
    links: "enlaces",
    user: "Usuario",
    item: "artículo",
    items: "artículos",
    moreItems: "más artículos",
    in: "Entrar",
    join: "Unirse",
    new: "Nuevo",
    pro: "Pro",
    free: "Gratis",
    seller: "Vendedor",
    starter: "Inicial",
    proSeller: "Vendedor Pro",
    admin: "Admin",
    rating: "Valoración",
    level: "Nivel",
    xp: "XP",
    myAccount: "Mi cuenta",
    buyAndSell: "Comprar y vender",
    discover: "Descubrir",
    selling: "Vender",
    accountGroup: "Cuenta",
    getStarted: "Comenzar",
    analytics: "Analíticas",
    subscription: "Suscripción",
    managePlan: "Gestionar plan",
    upgradePlan: "Mejorar plan",
    switchToDark: "Cambiar a oscuro",
    switchToLight: "Cambiar a claro",
    upgradeToSeller: "Actualizar a vendedor",
    upgradeToSellerDesc: "30 anuncios, Estudio IA y 1 impulso",
    createFreeAccount: "Crear cuenta gratis",

    megaVehiclesDesc: "Coches, motos, camiones",
    megaMobilesDesc: "Teléfonos y tablets",
    megaElectronicsDesc: "Portátiles, TVs, audio",
    megaPropertyDesc: "Casas, terrenos, comercial",
    megaFeedDesc: "Todos los anuncios activos",
    megaMessengerDesc: "Chat comprador y vendedor",
    megaMomentoDesc: "Historias y reels",
    megaAiStudioDesc: "Genera y edita imágenes",
    megaPostAdDesc: "Publica un artículo",
    megaMyListingsDesc: "Gestiona tus anuncios",
    megaLiveSalesDesc: "Ventas y cartera",
    megaPremiumDesc: "Mejora o gestiona tu plan",

    browseMobilesDesc: "iPhone, Samsung, Xiaomi y más",
    browseVehiclesDesc: "Sedanes, SUVs, motos",
    browseElectronicsDesc: "Portátiles, TVs, cámaras",
    browsePropertyDesc: "Casas, terrenos, comercial",
    browseFeedDesc: "Todos los anuncios activos",
    browseMessengerDesc: "Chatea con compradores y vendedores",
    browseMomentoDesc: "Comparte tus momentos e historias",
    browseAiStudioDesc: "Genera imágenes y quita el fondo",

    acctPostAdDesc: "Publica un artículo",
    acctMyListingsDesc: "Gestiona tus anuncios",
    acctAnalyticsDesc: "Vistas y rendimiento",
    acctSettingsDesc: "Perfil y preferencias",
    acctLiveSalesDesc: "Ventas y valor",
    acctPremiumDesc: "Mejorar o gestionar",

    features: "Funciones",
    assets: "Recursos",
    pricing: "Precios",
    faq: "Preguntas",
    protection: "Protección",
  },

  /* ═══════════════ FRENCH ═══════════════ */
  fr: {
    search: "Rechercher des articles..",
    home: "Accueil",
    feed: "Marché",
    vehicles: "Véhicules",
    mobiles: "Mobiles",
    electronics: "Électronique",
    property: "Immobilier",
    toys: "Jouets",
    premium: "Premium",
    messenger: "Messages",
    momento: "Momento",
    aiStudio: "Studio IA",
    postAd: "Publier une annonce",
    myListings: "Mes annonces",
    liveSales: "Ventes en direct",
    settings: "Paramètres",
    contactUs: "Contactez-nous",
    adminDashboard: "Tableau de bord",
    login: "Connexion",
    signup: "S'inscrire",
    logout: "Déconnexion",
    editProfile: "Modifier le profil",
    currentPlan: "Forfait actuel",
    reviews: "avis",
    noReviews: "Aucun avis",
    setLanguageAndCurrency: "Langue et devise",
    setLanguageDesc: "Sélectionnez votre langue et devise préférées. Vous pouvez modifier les paramètres à tout moment.",
    language: "Langue",
    currency: "Devise",
    save: "Enregistrer",
    cancel: "Annuler",
    viewDetails: "Voir détails",
    visit: "Visiter",
    buy: "Acheter",
    sold: "Vendu",
    chat: "Discuter",
    call: "Appeler",
    whatsapp: "WhatsApp",
    addToBag: "Ajouter au panier",
    buyNow: "Acheter maintenant",
    quantity: "Quantité",
    description: "Description",
    specifications: "Spécifications",
    safetyTips: "Conseils de sécurité",
    filterBy: "Filtrer par",
    resetAll: "Tout réinitialiser",
    priceRange: "Gamme de prix",
    from: "De",
    to: "À",
    carBrand: "Marque de voiture",
    searchBrand: "Rechercher une marque",
    condition: "État",
    color: "Couleur",
    availableNow: "Disponible maintenant",
    show: "Afficher",
    results: "résultats",
    yourCart: "Votre panier",
    emptyCart: "Votre panier est vide",
    subtotal: "Sous-total",
    viewFullCart: "Voir le panier",
    typeMessage: "Écrivez un message…",
    selectConversation: "Sélectionnez une conversation",
    noConversation: "Aucune conversation sélectionnée",
    quickReplies: "Réponses rapides",
    chattingAbout: "Discussion sur",
    loading: "Chargement…",
    saveThis: "Enregistrer",
    saved: "Enregistré",
    share: "Partager",
    report: "Signaler",

    menu: "Menu",
    searchFor: "Rechercher",
    popularCategories: "Catégories populaires",
    browseAllCategories: "Parcourir toutes les catégories",
    links: "liens",
    user: "Utilisateur",
    item: "article",
    items: "articles",
    moreItems: "plus d'articles",
    in: "Entrer",
    join: "Rejoindre",
    new: "Nouveau",
    pro: "Pro",
    free: "Gratuit",
    seller: "Vendeur",
    starter: "Débutant",
    proSeller: "Vendeur Pro",
    admin: "Admin",
    rating: "Note",
    level: "Niveau",
    xp: "XP",
    myAccount: "Mon compte",
    buyAndSell: "Acheter et vendre",
    discover: "Découvrir",
    selling: "Vendre",
    accountGroup: "Compte",
    getStarted: "Commencer",
    analytics: "Analyses",
    subscription: "Abonnement",
    managePlan: "Gérer le forfait",
    upgradePlan: "Améliorer le forfait",
    switchToDark: "Passer au sombre",
    switchToLight: "Passer au clair",
    upgradeToSeller: "Devenir vendeur",
    upgradeToSellerDesc: "30 annonces, Studio IA et 1 boost",
    createFreeAccount: "Créer un compte gratuit",

    megaVehiclesDesc: "Voitures, motos, camions",
    megaMobilesDesc: "Téléphones et tablettes",
    megaElectronicsDesc: "Ordinateurs, TVs, audio",
    megaPropertyDesc: "Maisons, terrains, commercial",
    megaFeedDesc: "Toutes les annonces actives",
    megaMessengerDesc: "Chat acheteur et vendeur",
    megaMomentoDesc: "Stories et reels",
    megaAiStudioDesc: "Générer et modifier des images",
    megaPostAdDesc: "Publier un nouvel article",
    megaMyListingsDesc: "Gérer vos annonces",
    megaLiveSalesDesc: "Ventes et portefeuille",
    megaPremiumDesc: "Améliorer ou gérer le forfait",

    browseMobilesDesc: "iPhone, Samsung, Xiaomi et plus",
    browseVehiclesDesc: "Berlines, SUV, motos",
    browseElectronicsDesc: "Ordinateurs, TVs, appareils photo",
    browsePropertyDesc: "Maisons, terrains, commercial",
    browseFeedDesc: "Toutes les annonces actives",
    browseMessengerDesc: "Discutez avec acheteurs et vendeurs",
    browseMomentoDesc: "Partagez vos moments et histoires",
    browseAiStudioDesc: "Générez des images et supprimez le fond",

    acctPostAdDesc: "Publier un nouvel article",
    acctMyListingsDesc: "Gérer vos annonces",
    acctAnalyticsDesc: "Vues et performances",
    acctSettingsDesc: "Profil et préférences",
    acctLiveSalesDesc: "Ventes et valeur",
    acctPremiumDesc: "Améliorer ou gérer",

    features: "Fonctionnalités",
    assets: "Ressources",
    pricing: "Tarifs",
    faq: "FAQ",
    protection: "Protection",
  },

  /* ═══════════════ GERMAN ═══════════════ */
  de: {
    search: "Artikel suchen..",
    home: "Startseite",
    feed: "Marktplatz",
    vehicles: "Fahrzeuge",
    mobiles: "Handys",
    electronics: "Elektronik",
    property: "Immobilien",
    toys: "Spielzeug",
    premium: "Premium",
    messenger: "Nachrichten",
    momento: "Momento",
    aiStudio: "KI-Studio",
    postAd: "Anzeige aufgeben",
    myListings: "Meine Anzeigen",
    liveSales: "Live-Verkäufe",
    settings: "Einstellungen",
    contactUs: "Kontakt",
    adminDashboard: "Admin-Panel",
    login: "Anmelden",
    signup: "Registrieren",
    logout: "Abmelden",
    editProfile: "Profil bearbeiten",
    currentPlan: "Aktueller Plan",
    reviews: "Bewertungen",
    noReviews: "Keine Bewertungen",
    setLanguageAndCurrency: "Sprache und Währung",
    setLanguageDesc: "Wählen Sie Ihre bevorzugte Sprache und Währung. Sie können die Einstellungen jederzeit ändern.",
    language: "Sprache",
    currency: "Währung",
    save: "Speichern",
    cancel: "Abbrechen",
    viewDetails: "Details ansehen",
    visit: "Besuchen",
    buy: "Kaufen",
    sold: "Verkauft",
    chat: "Chat",
    call: "Anrufen",
    whatsapp: "WhatsApp",
    addToBag: "In den Warenkorb",
    buyNow: "Jetzt kaufen",
    quantity: "Menge",
    description: "Beschreibung",
    specifications: "Spezifikationen",
    safetyTips: "Sicherheitstipps",
    filterBy: "Filtern nach",
    resetAll: "Alle zurücksetzen",
    priceRange: "Preisspanne",
    from: "Von",
    to: "Bis",
    carBrand: "Automarke",
    searchBrand: "Marke suchen",
    condition: "Zustand",
    color: "Farbe",
    availableNow: "Nur verfügbar",
    show: "Anzeigen",
    results: "Ergebnisse",
    yourCart: "Ihr Warenkorb",
    emptyCart: "Ihr Warenkorb ist leer",
    subtotal: "Zwischensumme",
    viewFullCart: "Warenkorb ansehen",
    typeMessage: "Nachricht schreiben…",
    selectConversation: "Wählen Sie ein Gespräch",
    noConversation: "Kein Gespräch ausgewählt",
    quickReplies: "Schnellantworten",
    chattingAbout: "Chat über",
    loading: "Wird geladen…",
    saveThis: "Speichern",
    saved: "Gespeichert",
    share: "Teilen",
    report: "Melden",

    menu: "Menü",
    searchFor: "Suche nach",
    popularCategories: "Beliebte Kategorien",
    browseAllCategories: "Alle Kategorien durchsuchen",
    links: "Links",
    user: "Benutzer",
    item: "Artikel",
    items: "Artikel",
    moreItems: "weitere Artikel",
    in: "Anmelden",
    join: "Beitreten",
    new: "Neu",
    pro: "Pro",
    free: "Gratis",
    seller: "Verkäufer",
    starter: "Starter",
    proSeller: "Pro-Verkäufer",
    admin: "Admin",
    rating: "Bewertung",
    level: "Stufe",
    xp: "XP",
    myAccount: "Mein Konto",
    buyAndSell: "Kaufen & Verkaufen",
    discover: "Entdecken",
    selling: "Verkaufen",
    accountGroup: "Konto",
    getStarted: "Loslegen",
    analytics: "Analysen",
    subscription: "Abonnement",
    managePlan: "Plan verwalten",
    upgradePlan: "Plan upgraden",
    switchToDark: "Zu Dunkel wechseln",
    switchToLight: "Zu Hell wechseln",
    upgradeToSeller: "Zu Verkäufer upgraden",
    upgradeToSellerDesc: "30 Anzeigen, KI-Studio & 1 Boost",
    createFreeAccount: "Kostenloses Konto erstellen",

    megaVehiclesDesc: "Autos, Motorräder, LKWs",
    megaMobilesDesc: "Handys & Tablets",
    megaElectronicsDesc: "Laptops, TVs, Audio",
    megaPropertyDesc: "Häuser, Grundstücke, Gewerbe",
    megaFeedDesc: "Alle Live-Anzeigen",
    megaMessengerDesc: "Käufer- & Verkäufer-Chat",
    megaMomentoDesc: "Storys & Reels",
    megaAiStudioDesc: "Bilder erstellen & bearbeiten",
    megaPostAdDesc: "Neuen Artikel einstellen",
    megaMyListingsDesc: "Verwalte deine Anzeigen",
    megaLiveSalesDesc: "Verkäufe & Wallet",
    megaPremiumDesc: "Plan upgraden oder verwalten",

    browseMobilesDesc: "iPhone, Samsung, Xiaomi & mehr",
    browseVehiclesDesc: "Limousinen, SUVs, Motorräder",
    browseElectronicsDesc: "Laptops, TVs, Kameras",
    browsePropertyDesc: "Häuser, Grundstücke, Gewerbe",
    browseFeedDesc: "Alle Live-Anzeigen",
    browseMessengerDesc: "Chatte mit Käufern & Verkäufern",
    browseMomentoDesc: "Teile deine Momente & Storys",
    browseAiStudioDesc: "Bilder erstellen & BG entfernen",

    acctPostAdDesc: "Neuen Artikel einstellen",
    acctMyListingsDesc: "Verwalte deine Anzeigen",
    acctAnalyticsDesc: "Aufrufe & Leistung",
    acctSettingsDesc: "Profil & Einstellungen",
    acctLiveSalesDesc: "Verkäufe & Wert",
    acctPremiumDesc: "Upgraden oder verwalten",

    features: "Funktionen",
    assets: "Ressourcen",
    pricing: "Preise",
    faq: "FAQ",
    protection: "Schutz",
  },

  /* ═══════════════ TURKISH ═══════════════ */
  tr: {
    search: "Ürün ara..",
    home: "Anasayfa",
    feed: "Pazar",
    vehicles: "Araçlar",
    mobiles: "Cep Telefonları",
    electronics: "Elektronik",
    property: "Emlak",
    toys: "Oyuncaklar",
    premium: "Premium",
    messenger: "Mesajlar",
    momento: "Momento",
    aiStudio: "AI Stüdyo",
    postAd: "İlan Ver",
    myListings: "İlanlarım",
    liveSales: "Canlı Satış",
    settings: "Ayarlar",
    contactUs: "İletişim",
    adminDashboard: "Yönetici Paneli",
    login: "Giriş Yap",
    signup: "Kayıt Ol",
    logout: "Çıkış Yap",
    editProfile: "Profili Düzenle",
    currentPlan: "Mevcut Plan",
    reviews: "yorum",
    noReviews: "Yorum yok",
    setLanguageAndCurrency: "Dil ve para birimi",
    setLanguageDesc: "Tercih ettiğiniz dili ve para birimini seçin. Ayarları istediğiniz zaman güncelleyebilirsiniz.",
    language: "Dil",
    currency: "Para Birimi",
    save: "Kaydet",
    cancel: "İptal",
    viewDetails: "Detayları Gör",
    visit: "Ziyaret Et",
    buy: "Satın Al",
    sold: "Satıldı",
    chat: "Sohbet",
    call: "Ara",
    whatsapp: "WhatsApp",
    addToBag: "Sepete ekle",
    buyNow: "Şimdi al",
    quantity: "Adet",
    description: "Açıklama",
    specifications: "Özellikler",
    safetyTips: "Güvenlik İpuçları",
    filterBy: "Filtrele",
    resetAll: "Tümünü Sıfırla",
    priceRange: "Fiyat Aralığı",
    from: "Başlangıç",
    to: "Bitiş",
    carBrand: "Araba Markası",
    searchBrand: "Marka ara",
    condition: "Durum",
    color: "Renk",
    availableNow: "Şu an müsait",
    show: "Göster",
    results: "sonuç",
    yourCart: "Sepetiniz",
    emptyCart: "Sepetiniz boş",
    subtotal: "Ara Toplam",
    viewFullCart: "Sepeti görüntüle",
    typeMessage: "Bir mesaj yazın…",
    selectConversation: "Bir sohbet seçin",
    noConversation: "Sohbet seçilmedi",
    quickReplies: "Hızlı yanıtlar",
    chattingAbout: "Şunun hakkında konuşuyorsunuz",
    loading: "Yükleniyor…",
    saveThis: "Kaydet",
    saved: "Kaydedildi",
    share: "Paylaş",
    report: "Bildir",

    menu: "Menü",
    searchFor: "Ara",
    popularCategories: "Popüler kategoriler",
    browseAllCategories: "Tüm kategorilere göz at",
    links: "bağlantı",
    user: "Kullanıcı",
    item: "ürün",
    items: "ürün",
    moreItems: "daha fazla ürün",
    in: "Giriş",
    join: "Katıl",
    new: "Yeni",
    pro: "Pro",
    free: "Ücretsiz",
    seller: "Satıcı",
    starter: "Başlangıç",
    proSeller: "Pro Satıcı",
    admin: "Yönetici",
    rating: "Puan",
    level: "Seviye",
    xp: "XP",
    myAccount: "Hesabım",
    buyAndSell: "Al & Sat",
    discover: "Keşfet",
    selling: "Satış",
    accountGroup: "Hesap",
    getStarted: "Başla",
    analytics: "Analitik",
    subscription: "Abonelik",
    managePlan: "Planı Yönet",
    upgradePlan: "Planı Yükselt",
    switchToDark: "Koyu temaya geç",
    switchToLight: "Açık temaya geç",
    upgradeToSeller: "Satıcı ol",
    upgradeToSellerDesc: "30 ilan, AI Stüdyo ve 1 öne çıkarma",
    createFreeAccount: "Ücretsiz Hesap Oluştur",

    megaVehiclesDesc: "Arabalar, motosikletler, kamyonlar",
    megaMobilesDesc: "Telefonlar ve tabletler",
    megaElectronicsDesc: "Laptoplar, TV'ler, ses",
    megaPropertyDesc: "Evler, arsalar, ticari",
    megaFeedDesc: "Tüm canlı ilanlar",
    megaMessengerDesc: "Alıcı ve satıcı sohbeti",
    megaMomentoDesc: "Hikayeler ve reels",
    megaAiStudioDesc: "Görsel oluştur ve düzenle",
    megaPostAdDesc: "Yeni ürün yayınla",
    megaMyListingsDesc: "İlanlarını yönet",
    megaLiveSalesDesc: "Satışlar ve cüzdan",
    megaPremiumDesc: "Planı yükselt veya yönet",

    browseMobilesDesc: "iPhone, Samsung, Xiaomi ve daha fazlası",
    browseVehiclesDesc: "Sedanlar, SUV'lar, motosikletler",
    browseElectronicsDesc: "Laptoplar, TV'ler, kameralar",
    browsePropertyDesc: "Evler, arsalar, ticari",
    browseFeedDesc: "Tüm canlı ilanlar",
    browseMessengerDesc: "Alıcılar ve satıcılarla sohbet et",
    browseMomentoDesc: "Anlarını ve hikayelerini paylaş",
    browseAiStudioDesc: "Görsel oluştur ve BG kaldır",

    acctPostAdDesc: "Yeni ürün yayınla",
    acctMyListingsDesc: "İlanlarını yönet",
    acctAnalyticsDesc: "Görüntülemeler ve performans",
    acctSettingsDesc: "Profil ve tercihler",
    acctLiveSalesDesc: "Satışlar ve değer",
    acctPremiumDesc: "Yükselt veya yönet",

    features: "Özellikler",
    assets: "Kaynaklar",
    pricing: "Fiyatlandırma",
    faq: "SSS",
    protection: "Koruma",
  },
};

/* ⭐ RTL languages */
export const RTL_LANGUAGES = ["ar", "ur", "he", "fa"];